import * as React from 'react';
import * as s from './DefaultTooltip.scss';
import { TourTooltipProps } from '../TourTooltipWrapper';

export class DefaultTooltip extends React.Component<TourTooltipProps> {
  renderButtons = () =>
    this.props.buttons.map((button) => (
      <button key={button.label} onClick={button.onClick}>
        {button.label}
      </button>
    ));

  render() {
    return (
      <div className={s.assistantTooltip} data-hook="tour-default-tooltip">
        {this.props.content}
        {this.props.buttons && this.renderButtons()}
      </div>
    );
  }
}
